var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid px-5", attrs: { id: "agents-container" } },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("agent-details-header", {
                attrs: {
                  loading: _vm.loading,
                  agent: _vm.agent,
                  "can-save": _vm.canSave,
                  saving: _vm.saving,
                  "saving-succeeded": _vm.savingSucceeded,
                },
                on: { submit: _vm.handleSubmit },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card p-2" },
                [
                  _c("navbar", {
                    attrs: { "current-tab": _vm.currentTab, tabs: _vm.tabs },
                    on: { "tab-change": _vm.handleTabChange },
                  }),
                  _vm._v(" "),
                  _vm.isDetailsTabActive && _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "p-3" },
                        [_c("agent-details-loader")],
                        1
                      )
                    : _vm.isDetailsTabActive
                    ? _c(
                        "b-row",
                        {
                          staticClass:
                            "align-items-center justify-content-center m-4",
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  label: _vm.$t("account.givenName"),
                                  "required-indicator": "",
                                },
                                model: {
                                  value: _vm.agent.givenName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "givenName", $$v)
                                  },
                                  expression: "agent.givenName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  label: _vm.$t("account.familyName"),
                                  "required-indicator": "",
                                },
                                model: {
                                  value: _vm.agent.familyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "familyName", $$v)
                                  },
                                  expression: "agent.familyName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("material-input", {
                                attrs: {
                                  label: _vm.$t("account.email"),
                                  "required-indicator": "",
                                  "read-only": "",
                                  type: "email",
                                },
                                model: {
                                  value: _vm.agent.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "email", $$v)
                                  },
                                  expression: "agent.email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "material-input",
                                {
                                  attrs: {
                                    label: _vm.$t("account.phoneNumber"),
                                    "required-indicator": "",
                                  },
                                  model: {
                                    value: _vm.agent.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.agent, "phoneNumber", $$v)
                                    },
                                    expression: "agent.phoneNumber",
                                  },
                                },
                                [
                                  _c("phone-input", {
                                    staticClass:
                                      "material-input form-control form",
                                    class: {
                                      "form-control-filled":
                                        _vm.agent.phoneNumber,
                                    },
                                    attrs: {
                                      name: "phoneNoFill",
                                      title: _vm.$t(
                                        "account.form.validPhoneNumber"
                                      ),
                                      type: "text",
                                      "data-lpignore": "true",
                                      "emit-value": "",
                                      value: _vm.agent.phoneNumber,
                                    },
                                    on: {
                                      change: function (val) {
                                        return (_vm.agent.phoneNumber = val)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "material-input",
                                {
                                  attrs: {
                                    label: _vm.$t("account.altPhoneNumber"),
                                  },
                                  model: {
                                    value: _vm.agent.altPhoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.agent, "altPhoneNumber", $$v)
                                    },
                                    expression: "agent.altPhoneNumber",
                                  },
                                },
                                [
                                  _c("phone-input", {
                                    staticClass:
                                      "material-input form-control form",
                                    class: {
                                      "form-control-filled":
                                        _vm.agent.altPhoneNumber,
                                    },
                                    attrs: {
                                      name: "phoneNoFill",
                                      title: _vm.$t(
                                        "account.form.validPhoneNumber"
                                      ),
                                      type: "text",
                                      "data-lpignore": "true",
                                      "emit-value": true,
                                      value: _vm.agent.altPhoneNumber,
                                    },
                                    on: {
                                      change: function (val) {
                                        return (_vm.agent.altPhoneNumber = val)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isClientsTabActive && _vm.loadingClients
                    ? _c(
                        "div",
                        { staticClass: "p-3" },
                        [_c("agents-loader")],
                        1
                      )
                    : _vm.isClientsTabActive
                    ? _c("agent-clients-table", {
                        attrs: {
                          "agent-id": _vm.agentId,
                          clients: _vm.computedAgent.clients,
                          loading: _vm.sortingClients,
                        },
                        on: { sort: _vm.handleSort },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAccessRightsTabActive
                    ? _c(
                        "div",
                        { staticClass: "m-4" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("access-rights.viewOnly")
                                            ) +
                                            ": "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "pretty p-switch p-fill mr-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray label-before",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("global.words.no")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.viewOnly,
                                                expression: "viewOnly",
                                              },
                                            ],
                                            attrs: {
                                              id: "view-only",
                                              name: "viewOnly",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.viewOnly
                                              )
                                                ? _vm._i(_vm.viewOnly, null) >
                                                  -1
                                                : _vm.viewOnly,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = _vm.viewOnly,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.viewOnly =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.viewOnly = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.viewOnly = $$c
                                                  }
                                                },
                                                _vm.changeRightsToNo,
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "state d-inline-block",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "view-only" } },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.yes"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "access-rights.editCommissions"
                                              )
                                            ) +
                                            ":\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "pretty p-switch p-fill mr-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray label-before",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("global.words.no")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.editCommissions,
                                                expression: "editCommissions",
                                              },
                                            ],
                                            attrs: {
                                              id: "edit-commissions",
                                              name: "editCommissions",
                                              type: "checkbox",
                                              disabled: _vm.viewOnly,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.editCommissions
                                              )
                                                ? _vm._i(
                                                    _vm.editCommissions,
                                                    null
                                                  ) > -1
                                                : _vm.editCommissions,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.editCommissions,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.editCommissions =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.editCommissions = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.editCommissions = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "state d-inline-block",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "edit-commissions",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.yes"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("access-rights.coBroker")
                                            ) +
                                            ": "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.left",
                                              value: {
                                                title: _vm.$t(
                                                  "global.messages.coBrokerFunctionalityDisabled"
                                                ),
                                                disabled:
                                                  _vm.overrideCobrokering,
                                              },
                                              expression:
                                                "{\n                    title: $t(\n                      'global.messages.coBrokerFunctionalityDisabled'\n                    ),\n                    disabled: overrideCobrokering\n                  }",
                                              modifiers: { left: true },
                                            },
                                          ],
                                          staticClass:
                                            "pretty p-switch p-fill mr-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray label-before",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("global.words.no")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.coBroker,
                                                expression: "coBroker",
                                              },
                                            ],
                                            attrs: {
                                              id: "co-broker",
                                              name: "coBroker",
                                              type: "checkbox",
                                              disabled:
                                                _vm.viewOnly ||
                                                !_vm.overrideCobrokering,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.coBroker
                                              )
                                                ? _vm._i(_vm.coBroker, null) >
                                                  -1
                                                : _vm.coBroker,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.coBroker,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.coBroker =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.coBroker = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.coBroker = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "state d-inline-block",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "co-broker" } },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.yes"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "access-rights.submitApplications"
                                              )
                                            ) +
                                            ":\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "pretty p-switch p-fill mr-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray label-before",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("global.words.no")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.submitApplications,
                                                expression:
                                                  "submitApplications",
                                              },
                                            ],
                                            attrs: {
                                              id: "submit-application",
                                              name: "submitApplications",
                                              type: "checkbox",
                                              disabled: _vm.viewOnly,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.submitApplications
                                              )
                                                ? _vm._i(
                                                    _vm.submitApplications,
                                                    null
                                                  ) > -1
                                                : _vm.submitApplications,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.submitApplications,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.submitApplications =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.submitApplications =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.submitApplications = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "state d-inline-block",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "submit-application",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.yes"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "access-rights.requestCreditBureau"
                                              )
                                            ) +
                                            ":\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "pretty p-switch p-fill mr-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "text-light-gray label-before",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("global.words.no")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.requestBureau,
                                                expression: "requestBureau",
                                              },
                                            ],
                                            attrs: {
                                              id: "request-bureau",
                                              name: "requestBureau",
                                              type: "checkbox",
                                              disabled: _vm.viewOnly,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.requestBureau
                                              )
                                                ? _vm._i(
                                                    _vm.requestBureau,
                                                    null
                                                  ) > -1
                                                : _vm.requestBureau,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.requestBureau,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.requestBureau =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.requestBureau = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.requestBureau = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "state d-inline-block",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "request-bureau",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.yes"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }